import { useMemo } from "react";

import { Edit } from "components/icons/generated";
import Box from "ds/components/Box";
import ButtonIcon from "ds/components/ButtonIcon";
import CardCollapsible from "ds/components/Card/Collapsible";
import Counter from "ds/components/Counter";
import Tag from "ds/components/Tag";
import { useToggle } from "hooks/useToggle";
import { AwsRegion } from "types/generated";

type DefinedRegionsCardProps = {
  regions: string[];
  regionOptions: Array<Pick<AwsRegion, "id" | "location">>;
  onEditRegions: () => void;
};

const DefinedRegionsCard = ({ regions, regionOptions, onEditRegions }: DefinedRegionsCardProps) => {
  const [isCollapsed, toggleCollapsed] = useToggle(false);

  const regionLabels = useMemo(
    () =>
      regions.map((region) => {
        const option = regionOptions.find((option) => option.id === region);
        return option ? `${option.location} (${option.id})` : region;
      }),
    [regions, regionOptions]
  );

  return (
    <CardCollapsible
      fullWidth
      ariaLevel={3}
      ariaLabel="Defined regions"
      title="Defined regions"
      titleSuffix={<Counter size="small" count={regions.length} />}
      isCollapsed={isCollapsed}
      onToggle={toggleCollapsed}
      headerSuffix={
        <ButtonIcon icon={Edit} variant="ghost" onPress={onEditRegions}>
          Edit regions
        </ButtonIcon>
      }
    >
      <Box direction="column" gap="medium">
        <Box gap="small" wrap grow="1">
          {regionLabels.map((label, index) => (
            <Tag key={regions[index]} tag={label} />
          ))}
        </Box>
      </Box>
    </CardCollapsible>
  );
};

export default DefinedRegionsCard;
